import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { environment } from '../environment.ts/environment';

@Component({
  selector: 'app-mentions-legales',
  standalone: true,
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './mentions-legales.component.html',
  styleUrl: './mentions-legales.component.scss'
})
export class MentionsLegalesComponent implements OnInit {
  supportEmail = environment.supportEmail;

  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    // Définir le titre de la page (60 caractères - optimal)
    this.title.setTitle('Mentions légales – Éditeur, hébergeur, site pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Retrouvez les mentions légales de pdf-to-word.fr : informations sur l\'éditeur, l\'hébergeur, la propriété intellectuelle, la responsabilité et les contacts.' });
    this.meta.updateTag({ name: 'keywords', content: 'mentions légales pdf-to-word, éditeur site web, hébergement site, propriété intellectuelle, responsabilité juridique, CGU site internet' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Mentions légales – Éditeur, hébergeur, site pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Retrouvez les mentions légales de pdf-to-word.fr : informations sur l\'éditeur, l\'hébergeur, la propriété intellectuelle, la responsabilité et les contacts.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
    this.meta.updateTag({ name: 'author', content: 'Interactive Lab' });
  }

}
